import usePromotions from "common/datahooks/usePromotions";

import GetPlan from "./GetPlan";
import PlanDetails from "./PlanDetails";

export default function AgencyPlan() {
  const { agencyPlan } = usePromotions();

  if (agencyPlan) {
    return <PlanDetails />;
  }
  return <GetPlan />;
}
